import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Row 1: Dark maroon bar with links left + 24X7 Support right */}
      <div className="footer-links-bar">
        <div className="footer-links-left">
          <a href="#">Terms and Conditions</a>
          <a href="#">Responsible Gaming</a>
        </div>
        <div className="footer-links-right">
          <span className="support-text">24X7 Support</span>
        </div>
      </div>

      {/* Row 2: SSL badge left + 18+/G/GT logos right */}
      <div className="footer-badges">
        <div className="footer-badges-left">
          <img
            src={require("../../assets/img/footerimg/ssl.png")}
            alt="SSL Secure"
            className="ssl-badge"
          />
          <div className="safe-text">
            <strong>100% SAFE</strong>
            <span>Protected connection and encrypted data.</span>
          </div>
        </div>
        <div className="footer-badges-right">
          <img
            src={require("../../assets/img/footerimg/18plus.png")}
            alt="18+"
            className="badge-icon-img"
          />
          <img
            src={require("../../assets/img/footerimg/gamecare.png")}
            alt="Gamecare"
            className="badge-icon-img"
          />
          <img
            src={require("../../assets/img/footerimg/gt.png")}
            alt="GT"
            className="badge-icon-img"
          />
        </div>
      </div>

      {/* Row 3: Copyright centered */}
      <div className="footer-copyright">
        <p>&copy; Copyright 2026. All Rights Reserved. Powered by Allpanelexch9.</p>
      </div>
    </footer>
  );
};

export default Footer;
